/**
 * AuthUI component - Handles UI updates based on authentication state
 * 
 * @package PocketOption
 */

/**
 * Updates the UI for authenticated users
 * 
 * @param {Object} userData User data from authentication
 */
const updateAuthenticatedUI = (userData) => {
  // Update login button with user avatar
  updateLoginButton(userData);
  
  // Hide the mobile language switcher
  hideMobileLangSwitcher();
};

/**
 * Updates the login button with user avatar
 * 
 * @param {Object} userData User data from authentication
 */
const updateLoginButton = (userData) => {
  const loginButton = document.querySelector('.po-header__ui-btn.po-login');
  if (loginButton) {
    const svgImage = loginButton.querySelector('img, svg');
    if (svgImage && userData.avatar) {
      // Create new avatar image element
      const avatarImg = document.createElement('img');
      avatarImg.src = userData.avatar;
      avatarImg.alt = 'User Avatar';
      avatarImg.classList.add('user-avatar');
      
      // Replace the SVG with the avatar image
      svgImage.parentNode.replaceChild(avatarImg, svgImage);
      
      // Add class to indicate user is logged in
      loginButton.classList.add('po-header__ui-btn--authenticated');
    }

    // Change the href attribute to point to the cabinet page
    // loginButton.setAttribute('href', '/cabinet/');
    loginButton.setAttribute('href', '#');
  }
};

/**
 * Hides the mobile language switcher
 */
const hideMobileLangSwitcher = () => {
  const mobileLangSwitcher = document.querySelector('.pl-lang-switcher-mobile__actions');
  if (mobileLangSwitcher) {
    mobileLangSwitcher.style.visibility = 'hidden';
  }
};

/**
 * Updates the UI for unauthenticated users
 * Can be expanded in the future with additional functionality
 */
const updateUnauthenticatedUI = () => {
  // Currently nothing specific to do for unauthenticated users
  // This function exists for symmetry and future expansion
};

export {
  updateAuthenticatedUI,
  updateUnauthenticatedUI
};
